import {LOGIN, LOGOUT, VTR_TRIP_REQUEST} from "./actionTypes";

export const login = (payload , username , password) => {
    return {
        type: LOGIN,
        payload,
        username,
        password
    };
};

export const logout = () => {
    return {
        type: LOGOUT
    };
};

export const vtrTripApiRequest = (client_id , token , user_app_status,trip_id) => {
    return {
        type: VTR_TRIP_REQUEST,
        client_id,
        token,
        user_app_status,
        trip_id
    };
};
